import type { LaunchStateName } from '@localagent/sdk';

export const STARTUP_QUIPS = [
  'Sharpening the katana…',
  'Polishing the chopsticks…',
  'Negotiating with launchd…',
  'Asking the menu bar app to report for duty…',
  'Brewing matcha for the daemon…',
  'Raking the zen garden…',
  'Folding a very small crane…',
  'Counting ronin…',
] as const;

export function startupPhaseLine(phase: LaunchStateName | null): string {
  switch (phase) {
    case 'stale_runtime':
      return 'Swapping in the version you just installed';
    case 'registering':
      return 'Registering the background service';
    case 'bootstrapping':
      return 'Starting the background service and the menu bar app';
    case 'launched':
    case 'converging':
      return 'Checking on the background service';
    default:
      return 'Connecting to the background service';
  }
}
